<div class="restaurant-container">
<app-restaurant-header></app-restaurant-header>

  <div class="restaurant-body">
<app-page-header 
 [header]="'CART.TITLE' | translate" 
  [breadcrumbs]="[
    {label: 'CART.BREADCRUMB_HOME' | translate, url: root.home()},
    {label: 'CART.BREADCRUMB_CART' | translate, url: ''}
]">

 <div *ngIf="(account.showPrices$ | async) && items.length" class="d-lg-none" style="display: flex; align-items: center">
    {{ 'CART.TOTAL' | translate }}:&nbsp;
    <b>{{ cart.total$ | async | currencyFormat }}</b>
  </div>
</app-page-header>

<div class="block block-empty" *ngIf="!(account.showPrices$ | async)">
    <div class="container">
        <div class="block-empty__body">
            <div class="block-empty__message">
                {{ 'CART.NEED_LOGIN' | translate }}           
            </div>
                    <div class="block-empty__actions">
                <a [routerLink]="root.home()" class="btn btn-primary btn-sm">
                {{ 'CART.GO_HOME' | translate }}
                </a>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="account.showPrices$ | async">
    <div class="block block-empty" *ngIf="!items.length">
        <div class="container">
            <div class="block-empty__body">
                <div class="block-empty__message">{{ 'CART.EMPTY' | translate }}</div>
                <div class="block-empty__actions">
                    <a [routerLink]="root.shop()" class="btn btn-primary btn-sm"> {{ 'CART.CONTINUE' | translate }}</a>
                </div>
            </div>
        </div>
    </div>

    <div class="cart block" *ngIf="items.length">
        <div class="container">
            <div class="row cart-row">
                <div class="cart-content">
                    <table class="cart__table cart-table">
                        <thead class="cart-table__head">
                            <tr class="cart-table__row">
                                <th class="cart-table__column cart-table__column--image"></th>
                                <th class="cart-table__column cart-table__column--product">Articolo</th>
                                <th class="cart-table__column cart-table__column--price">Prezzo<div class="iva" *ngIf="b2b">IVA esclusa</div></th>
                                <th class="cart-table__column cart-table__column--quantity">Quantità</th>
                                <th class="cart-table__column cart-table__column--total">Totale<div class="iva" *ngIf="b2b">IVA esclusa</div></th>
                                <th class="cart-table__column cart-table__column--remove"></th>
                            </tr>
                        </thead>
                        <tbody class="cart-table__body">
                            <tr *ngFor="let item of items" class="cart-table__row" [ngClass]="{'cart-row-limit-error': curShipLimitErrorsObj[item.cartItem.product.codart]}">
                                <td class="cart-table__column cart-table__column--image">
                                    <div class="product-image">
                                        <a [routerLink]="root.product(item.cartItem.product)"
                                            class="product-image__body">
                                            <img class="product-image__img"
                                                [src]="item.cartItem.product.cdn_url" alt="">
                                        </a>
                                    </div>
                                </td>
                                <td class="cart-table__column cart-table__column--product">
                                    <a [routerLink]="root.product(item.cartItem.product)"
                                        class="cart-table__product-name">{{ item.cartItem.product.descart }}</a>
                                    
                                    <div *ngIf="item.cartItem.attributi?.length || item.cartItem.box_levels?.length">
                                        <a href="javascript:;" style="text-decoration: underline;"
                                        (click)="changeItemContent(item)"><small>Modifica contenuto</small></a>
                                    </div>

                                    <div style="color: gray;" *ngIf="item.cartItem.product.conf_active as conf">
                                        {{conf.codice_confezione}} ({{conf.pezzi_confezione}} pz.) × {{item.quantity / conf.pezzi_confezione}}
                                    </div>
                                    
                                    <ul *ngIf="item.cartItem.options" class="cart-table__options">
                                        <ng-container *ngFor="let i of [1, 2, 3, 4]">
                                            <li *ngIf="item.cartItem.options[i]">
                                                {{ item.cartItem.options[i].list.descrizione }}:
                                                {{ item.cartItem.options[i].option.codice }}</li>
                                        </ng-container>
                                    </ul>

                                    <div *ngIf="item.cartItem.box_levels && getBoxContentDescription(item) as desc" class="cart-table__options tooltip_wider">
                                        <div *ngFor="let box_item of desc.slice(0, desc.length == 3 ? 3 : 2)" [ngClass]="{'text-danger': box_item.haveError}">{{box_item.desc}}</div>
                                        <ng-template #compTemplate>
                                            <div *ngFor="let box_item of desc.slice(2)" [ngClass]="{'text-danger': box_item.haveError}">{{box_item.desc}}</div>
                                        </ng-template>
                                        <div *ngIf="desc.length != 3 && desc.length > 2"
                                            >... e altri {{desc.length - 2}} <i class="fa fa-info-circle" 
                                            style="cursor: pointer; color: #00adff"></i></div>
                                    </div>

                                    <div *ngIf="item.cartItem.attributi" class="cart-table__options tooltip_wider">
                                        <div *ngFor="let attribute of item.cartItem.attributi.slice(0, item.cartItem.attributi.length == 3 ? 3 : 2)">
                                            <span [ngClass]="{'text-danger': attribute.error}">
                                                + {{attribute.descrizione}}
                                                <ng-container *ngIf="attribute.prezzo">({{ attribute.prezzo | currencyFormat }})</ng-container>
                                            </span>
                                        </div>

                                        <ng-template #attrTemplate>
                                            <div *ngFor="let attribute of item.cartItem.attributi.slice(2)">
                                                <span [ngClass]="{'text-danger': attribute.error}">
                                                    + {{attribute.descrizione}}
                                                    <ng-container *ngIf="attribute.prezzo">({{ attribute.prezzo | currencyFormat }})</ng-container>
                                                </span>
                                            </div>
                                        </ng-template>
                                        <div *ngIf="item.cartItem.attributi.length != 3 && item.cartItem.attributi.length > 2"
                                            >... e altri {{item.cartItem.attributi.length - 2}} <i class="fa fa-info-circle" 
                                            style="cursor: pointer; color: #00adff"></i></div>
                                    </div>
                                </td>
                                <td class="cart-table__column cart-table__column--price" data-title="Prezzo">
                                    {{ cart.itemPriceWithAttributes(item.cartItem, true) | currencyFormat }}
                                   
                                    <div *ngIf="b2b" class="iva d-md-none">&nbsp;&nbsp;IVA esclusa</div>
                                </td>
                                <td class="cart-table__column cart-table__column--quantity"
                                    data-title="Quantità" style="position: relative;">
                                    <app-input-number [formControl]="item.quantityControl" [min]="min(item.cartItem.product)"
                                        [step]="step(item.cartItem.product)">
                                    </app-input-number>
                                    <small *ngIf="hasQuantityError(item, 'current') as error; else limit_err"
                                            class="cart-table__column--quantity-error">{{error}}</small>
                                    <ng-template #limit_err>
                                        <small *ngIf="curShipLimitErrorsObj[item.cartItem.product.codart] as limitErr"
                                            class="cart-table__column--quantity-error">{{limitErr}}</small>
                                    </ng-template>
                                </td>
                                <td class="cart-table__column cart-table__column--total" data-title="Totale">
                                    {{ cart.itemPriceWithAttributes(item.cartItem, true) * item.quantity | currencyFormat }}
                                    <div *ngIf="b2b" class="iva d-md-none">&nbsp;&nbsp;IVA esclusa</div>
                                </td>
                                <td class="cart-table__column cart-table__column--remove">
                                    <button type="button" class="btn btn-light btn-sm btn-svg-icon"
                                        (click)="remove(item.cartItem)"
                                        [ngClass]="{'btn-loading': removedItems.includes(item.cartItem)}">
                                        <app-icon name="cross-12" size="12"></app-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="aside-right">
                    <div class="card">
                        <div class="card-body">
                            <div *ngIf="this.account.user$ | async" style="border-bottom: 1px solid var(--light-divider-color); margin-bottom: 5px;padding-bottom: 10px;">
                                <div class="address-card__row">
                                    <div class="address-title">{{ 'CART.DESTINATION' | translate }}</div>
                                    <div class="address-card__row-content">
                                        <ng-container *ngIf="destinazioneScelta">
                                            {{ destinazioneScelta.ragioneSocialeDestinazione }}<br>
                                            {{ destinazioneScelta.indirizzoDestinazione }}<br>
                                            {{ destinazioneScelta.cap }}
                                            {{ destinazioneScelta.citta }}
                                            ({{ destinazioneScelta.prov }})
                                            <br><a class="addressLink" (click)="openAddressModal()"
                                                href="javascript:;">{{ 'CART.CHANGE' | translate }}</a>
                                            &nbsp;
                                        </ng-container>
                                        <a class="addressLink" routerLink="/account/addresses/new"
                                            [queryParams]="{'from': 'cart'}"> {{ 'CART.ADD_ADDRESS' | translate }}</a>
                                    </div>
                                </div>    
                            </div>

                            <table class="cart__totals">
                                <thead class="cart__totals-header">
                                    <tr>
                                        <th>{{ 'CART.ITEM_TOTAL' | translate }}</th>
                                        <td>{{ cart.subtotal$|async|currencyFormat }}
                                            <div *ngIf="b2b" class="iva">IVA esclusa</div>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody class="cart__totals-body" *ngIf="this.account.user$ | async">
                                    <tr>
                                        <td colspan="2">
                                            <div class="address-card__row" *ngIf="destinazioneScelta" style="padding-bottom: 3px;">
                                                <div class="address-title" style="margin-bottom:15px; display: flex; justify-content: space-between;
                                                ">{{ 'CART.SHIPPING_METHOD' | translate }}
                                                    <div *ngIf="b2b" class="iva" style="display: inline-block;">IVA esclusa</div>
                                                </div>
                                                <div class="address-card__row-content">
                                                    <div *ngIf="!modalitaDiSpedizione">
                                                        <ng-container *ngIf="!errDoc">
                                                            <div class="w-100 text-center">
                                                                <div class="fa-2x">
                                                                    <i class="fas fa-spinner fa-spin"></i>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                        <ng-container *ngIf="errDoc">
                                                            <div class="w-100 text-center text-danger">
                                                                {{errDoc}}
                                                            </div>
                                                        </ng-container>
                                                    </div>

                                                    <div *ngIf="modalitaDiSpedizione && !modalitaDiSpedizione.length">
                                                        Ops. Sicuro di aver messo tutto? Il tuo carrello sembra non raggiungere il minimo di spedizione oppure il tuo comune non è coperto.
                                                    </div>
                
                                                    <div class="filter-list">
                                                        <div class="filter-list__list">
                                                            <ng-container *ngFor="let tipo of [0, 2, 1]">
                                                                <ng-container *ngIf="getSpedizioneByType(tipo) as modalita">
                                                                    <label class="filter-list__item">
                                                                        <span class="filter-list__input input-radio">
                                                                            <span class="input-radio__body">
                                                                                <input class="input-radio__input" type="radio"
                                                                                    [value]="modalita.codice"
                                                                                    [formControl]="controlModalitaDiSpedizione">
                                                                                <span class="input-radio__circle"></span>
                                                                            </span>
                                                                        </span>
                        
                                                                        <span class="filter-list__title"
                                                                            style="font-size: 16px;">{{ getModalitaDiSpedizione(modalita.tipo_spedizione) }}</span>
                                                                        <span class="filter-list__counter"
                                                                            style="font-size:16px; color:black; font-weight: bold;">{{ this.shippingCost.getPriceOfShipping(modalita, this.cart.subtotal) | currencyFormat }}</span>
                                                                    </label>
                                                                    <div class="text-left" *ngIf="curShipLimitErrorsArr.length && modalita.codice == controlModalitaDiSpedizione.value">
                                                                        <small class="text-danger">Alcuni articoli non soddisfano le condizioni della spedizione, controlla il carrello 
                                                                            <ng-template #tolTemplate><table id="error-table"><tr *ngFor="let row of curShipLimitErrorsArr"><td class="error-info-cell">{{row.articolo}}</td><td class="error-info-cell">{{row.message}}</td></tr></table></ng-template>
                                                                            <i class="fa fa-info-circle"  placement="left" style="font-size: 20px; color: #00adff; cursor: pointer;"></i>
                                                                        </small>
                                                                    </div>
                                                                </ng-container>

                                                                <ng-container *ngIf="getSpedizioneNonDisponibileByType(tipo) as spedNonDisp">
                                                                    <label class="filter-list__item" style="color: #a2a2a2">
                                                                        <span class="filter-list__input input-radio">
                                                                            <span class="input-radio__body">
                                                                                <input class="input-radio__input" type="radio"
                                                                                    [value]="spedNonDisp.codice" disabled
                                                                                    [formControl]="controlModalitaDiSpedizione">
                                                                                <span class="input-radio__circle"></span>
                                                                            </span>
                                                                        </span>
                        
                                                                        <span class="filter-list__title"
                                                                            style="font-size: 16px;">{{ getModalitaDiSpedizione(spedNonDisp.tipo_spedizione) }}</span>
                                                                        <span class="filter-list__counter"
                                                                            style="font-size:16px; color: #a2a2a2">{{ this.shippingCost.getPriceOfShipping(spedNonDisp, this.cart.subtotal) | currencyFormat }}</span>
                                                                    </label>
                                                                    <div class="text-left">
                                                                        <small class="text-danger" *ngIf="spedNonDisp.reasons[0] == 1">{{ getModalitaDiSpedizione(spedNonDisp.tipo_spedizione) }} non disponibile: alcuni articoli non sono disponibili per questa spedizione
                                                                            <ng-template #tolTemplate><table id="error-table"><tr *ngFor="let row of spedNonDisp.error_data"><td class="error-info-cell">{{row.articolo}}</td><td class="error-info-cell">{{row.message}}</td></tr></table></ng-template>
                                                                            <i class="fa fa-info-circle" placement="left" style="font-size: 20px; color: #00adff; cursor: pointer;"></i>
                                                                        </small>
                                                                        <small class="text-danger" *ngIf="spedNonDisp.reasons[0] != 1">{{ getModalitaDiSpedizione(spedNonDisp.tipo_spedizione) }} non disponibile: {{ spedNonDisp.error_data }}</small>
                                                                    </div>
                                                                </ng-container>
                                                            </ng-container>
                                                        </div>
                                                    </div>
                
                                                </div>
                                            </div>

                                            <ng-container *ngIf="impostazioniRitiroAttivo()">
                                                <div class="address-card__row text-left" *ngIf="impostazioni_ritiro.messaggio_utenti">
                                                    {{impostazioni_ritiro.messaggio_utenti}}
                                                </div>
                                                <ng-container *ngIf="orarioRitiroAttivo()">
                                                    <div class="address-card__row">
                                                        <div class="address-title">{{ 'CART.PICKUP_DAY' | translate }} <span style="color: red">*</span></div>

                                                        <select class="form-control" [formControl]="ritiroGiorno" *ngIf="orariDisponibili.length">
                                                            <option disabled [ngValue]="null">{{ 'CART.PICKUP_DAY_SELECT' | translate }}</option>
                                                            <option *ngFor="let giorno of orariDisponibili"
                                                                [ngValue]="giorno.giorno">
                                                                {{formatDate(giorno.giorno)}}
                                                            </option>
                                                        </select>

                                                        <div *ngIf="!orariDisponibili.length" class="text-left">
                                                            {{ 'CART.NO_PICKUP_DAYS' | translate }}<br>
                                                        </div>
                                                    </div>
                
                                                    <div class="address-card__row"
                                                        *ngIf="orariDisponibili.length && ritiroGiorno.value">
                                                        <div class="address-title"> {{ 'CART.PICKUP_TIME' | translate }}
                                                            <span style="color: red">*</span></div>
                                                        <select class="form-control" [formControl]="ritiroRange">
                                                            <option disabled [ngValue]="null">{{ 'CART.PICKUP_TIME_SELECT' | translate }}</option>
                                                            <option
                                                                *ngFor="let orario of getOrariPerGiornoSelezionato()"
                                                                [ngValue]="orario">
                                                                {{formatTime(orario[0])}} - {{formatTime(orario[1])}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </ng-container>

                                                <div class="address-card__row" *ngIf="impostazioni_ritiro.flg_note">
                                                    <div class="address-title">{{ 'CART.NOTES' | translate }}</div>
                                                    <textarea [formControl]="note" class="form-control"
                                                        rows="2"></textarea>
                                                </div>
                
                                            </ng-container>
                
                                            <ng-container *ngIf="impostazioni_consegna?.attivo">
                                                <ng-container *ngIf="fasciaAttiva()">
                                                    <div class="address-card__row">
                                                        <div class="address-title">{{ 'CART.DELIVERY_DAY' | translate }}<span
                                                                *ngIf="impostazioni_consegna.flg_obb_data || impostazioni_consegna.flg_obb_fascia"
                                                                style="color: red">*</span></div>
                
                                                        <select class="form-control" [formControl]="fasciaGiorno">
                                                            <option
                                                                *ngIf="impostazioni_consegna.flg_obb_data || impostazioni_consegna.flg_obb_fascia"
                                                                disabled [ngValue]="null">{{ 'CART.DELIVERY_DAY_SELECT' | translate }}</option>
                                                            <option
                                                                *ngIf="!(impostazioni_consegna.flg_obb_data || impostazioni_consegna.flg_obb_fascia)"
                                                                [ngValue]="null">{{ 'CART.DELIVERY_DAY_ANY' | translate }}</option>
                                                            <option *ngFor="let fascia of fasceDisponibili"
                                                                [ngValue]="fascia.giorno">
                                                                {{formatDate(fascia.giorno)}}
                                                            </option>
                                                        </select>
                                                    </div>
                
                                                    <div class="address-card__row"
                                                        *ngIf="impostazioni_consegna.flg_fascia && fasciaGiorno.value">
                                                        <div class="address-title"> {{ 'CART.DELIVERY_TIME' | translate }}
                                                            <span *ngIf="impostazioni_consegna.flg_obb_fascia"
                                                                style="color: red">*</span></div>

                                                        <select class="form-control" [formControl]="fasciaOra">
                                                            <option *ngIf="impostazioni_consegna.flg_obb_fascia"
                                                                disabled [ngValue]="null">{{ 'CART.DELIVERY_TIME_SELECT' | translate }}
                                                            </option>
                                                            <option *ngIf="!impostazioni_consegna.flg_obb_fascia"
                                                                [ngValue]="null">{{ 'CART.DELIVERY_TIME_ANY' | translate }}</option>
                                                            <option
                                                                *ngFor="let fascia of getFascieOrariePerGiornoSelezionato()"
                                                                [ngValue]="fascia.id">
                                                                {{fascia.descrizione}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </ng-container>
                
                                                <div class="address-card__row" *ngIf="impostazioni_consegna.flg_note && !impostazioniRitiroAttivo()">
                                                    <div class="address-title">{{ 'CART.NOTES' | translate }}</div>
                                                    <textarea [formControl]="note" class="form-control"
                                                        rows="2"></textarea>
                                                </div>
                
                                            </ng-container>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot class="cart__totals-footer" *ngIf="this.account.user$ | async">
                                    <tr>
                                        <th>{{ 'CART.TOTAL' | translate }}</th>
                                        <td>{{ cart.total$|async|currencyFormat }}
                                            <div *ngIf="b2b" class="iva">IVA esclusa</div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                            <a class="btn btn-primary-darken btn-xl btn-block cart__checkout-button"
                                (click)="checkData()">{{ 'CART.CHECKOUT' | translate }}</a>
                            <button *ngIf="account.user$ | async" class="btn btn-secondary btn-sm mt-2" style="width: 100%"
                                (click)="cart.salvaCarrello()">{{ 'CART.SAVE_CART' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #modal>
    <div class="quickview">
        <button class="quickview__close" type="button" appClick (click)="modalRef.hide()">
            <app-icon name="cross-20" size="20"></app-icon>
        </button>

        <h1>{{ 'CART.CHOOSE_ADDRESS' | translate }}</h1>

        <div class="addresses-list">
            <ng-container *ngFor="let indirizzo of destinazioni">
                <div class="addresses-list__item card address-card">
                    <div class="address-card__badge" *ngIf="indirizzo.preferenziale">{{ 'CART.DEFAULT' | translate }}
                    </div>
                    <div class="address-card__body">
                        <div class="address-card__name">{{ indirizzo.ragioneSocialeDestinazione }}
                        </div>
                        <div class="address-card__row">
                            {{ indirizzo.indirizzoDestinazione }}<br>
                            {{ indirizzo.citta }} ({{ indirizzo.prov }})<br>
                            {{ indirizzo.cap }}
                        </div>
                        <div class="address-card__footer">
                            <a class="addressLink" href="javascript:;"
                                (click)="selectDestinazione(indirizzo)">{{ 'CART.SELECT' | translate }}</a>
                        </div>
                    </div>
                </div>
                <div class="addresses-list__divider"></div>
            </ng-container>
        </div>
    </div>
</ng-template>
</div>
 <app-restaurant-footer></app-restaurant-footer>
</div>
